import { addTrailingSlash, stagePrefix, type ApiEnv } from '@common/api'
import { PROD } from '../../config/stage'

// Pure API base-URL resolution shared by the app (src/io/api/**/baseUrl.ts, reading import.meta.env) and the e2e
// runner (e2e/utils/api.ts, reading process.env). Keep this module free of import.meta.env / Vite-only APIs so the
// CommonJS e2e runtime can import it.

export type ApiUrls = {
  apiBaseUrl: string
  entityApiUrl: string
  resourceBaseUrl: string
  formsBaseUrl: string
  syncApiBaseUrl: string
  insightsBaseUrl: string
}

export const resolveApiUrls = ({ stage, configuredApiBaseUrl }: ApiEnv): ApiUrls => {
  const configured = configuredApiBaseUrl?.trim()
  const hasConfiguredBaseUrl = !!configured && configured.length > 0

  const environmentPrefix = stage === PROD ? '' : 'shared-'
  const apiBaseUrl = addTrailingSlash(
    hasConfiguredBaseUrl && configured ? configured : `https://api.${environmentPrefix}platform.eidu.com/`
  )

  const prefix = stagePrefix(stage)
  // Insights uses a fixed `test-` prefix in non-prod rather than the actual stage.
  const insightsPrefix = stage === PROD ? '' : 'test-'

  return {
    apiBaseUrl,
    entityApiUrl: `${apiBaseUrl}${prefix}entities`,
    resourceBaseUrl: `${apiBaseUrl}${prefix}resources`,
    formsBaseUrl: `${apiBaseUrl}${prefix}forms`,
    syncApiBaseUrl: `${apiBaseUrl}${prefix}sync`,
    insightsBaseUrl: `${apiBaseUrl}${insightsPrefix}insights`,
  }
}
